import { Progress, Tooltip } from 'antd';
import { CheckOutlined, CloseOutlined,  MinusOutlined } from '@ant-design/icons';
import './styles.css';

const EOLProgressIcon = ({status, percent, showInfo, size}) => {
  const GREY = '#F4F4F4';
  const ORANGE = '#FFC100';
  const RED = '#F04438';
  const GREEN = '#12B76A';
 
  const getCustomColor = (status) => {
    let strokeColor;
    switch (status) {
        case 'GOOD':
        case 'IN_LIMIT':
        case 'PASS':
          strokeColor = GREEN; break;
        case 'AVERAGE':
          strokeColor = ORANGE; break;
        case 'POOR': 
        case 'LOWER_LIMIT':
        case 'UPPER_LIMIT':
        case 'FAIL':
          strokeColor = RED; break;
        default:
          strokeColor = GREY; break;
      }
      return strokeColor;
  }

  const renderCustomIcon = (status) => {
    let icon, toolTipText;
    switch (status) {
      case 'GOOD':
      case 'PASS':
        icon = <CheckOutlined  style={{ fontSize: 24, color: GREEN }} />; break;
      case 'AVERAGE':
        icon = <MinusOutlined style={{ fontSize: 24, color: ORANGE }} />; break;
      case 'POOR':
        icon = <CloseOutlined style={{ fontSize: 24, color: RED }} />; break;
      case 'IN_LIMIT':
        icon = <CheckOutlined  style={{ fontSize: 24, color: GREEN }} />; 
        toolTipText = "Within Range"; break;
      case 'LOWER_LIMIT':
        icon = <CloseOutlined style={{ fontSize: 24, color: RED }} />;
        toolTipText = "Lower Range"; break;
      case 'UPPER_LIMIT':
        icon = <CloseOutlined style={{ fontSize: 24, color: RED }} />;
        toolTipText = "Higher Range"; break;

      case 'FAIL':
        icon = <CloseOutlined style={{ fontSize: 24, color: RED }} />; break;
      default:
        break;
    }
    toolTipText = toolTipText ? toolTipText : status?.charAt(0).toUpperCase() + status?.slice(1).toLowerCase();
    return <Tooltip title={toolTipText} color={"#9e9f9f"}>{icon}</Tooltip>;
  };

  return (
      <Progress
        type="circle"
        percent={percent}
        showInfo={showInfo}
        // status={status}
        size={size}
        strokeColor={getCustomColor(status)}
        format={() => renderCustomIcon(status)} // Custom icon based on status
      />
  );
};

export default EOLProgressIcon;
